import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLetsencryptComponent } from './simple-icons-letsencrypt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLetsencryptComponent ],
    exports:      [ SimpleIconsLetsencryptComponent ],
    bootstrap:    []
})
export class SimpleIconsLetsencryptModule {}
